import { Button, Group, Text } from '@common/ui'
import React, { DetailedHTMLProps, useRef, useState } from 'react'

export type FileInputProps = {
  onChange(file: File): void
} & Omit<
  DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'onChange' | 'type' | 'ref' | 'style'
>

const FileInput: React.FC<FileInputProps> = ({ onChange, ...rest }) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [fileName, setFileName] = useState<string>('No file selected')

  const handleButtonClick = () => {
    if (inputRef.current) {
      inputRef.current.click()
    }
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setFileName(file.name)
      onChange(file)
      if (inputRef.current) {
        inputRef.current.value = ''
      }
    } else {
      setFileName('No file selected')
    }
  }

  return (
    <Group gap="md" align="center">
      <Button onClick={handleButtonClick} data-testid="file-input-select-button">
        Select File
      </Button>
      <Text>{fileName}</Text>
      <input
        {...rest}
        data-testid="file-input"
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </Group>
  )
}

export default FileInput
